<template>
  <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-hidden tw-bg-gradient-to-br tw-from-slate-50 tw-via-white tw-to-indigo-50">
        <div class="tw-border-b tw-border-slate-200/70 tw-px-4 tw-pb-3 tw-pt-3">
          <div class="tw-flex tw-flex-nowrap tw-items-center tw-justify-between tw-gap-3">
            <div class="tw-min-w-0 tw-flex-1 tw-overflow-x-auto">
              <div class="tw-flex tw-flex-nowrap tw-gap-2 tw-whitespace-nowrap">
                <button
                  type="button"
                  class="tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium"
                  :class="activeTab === 'details'
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                  @click="setTab('details')"
                >
                  Container Details
                </button>
                <button
                  type="button"
                  class="tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium"
                  :class="activeTab === 'notes'
                    ? (container?.notes?.length > 0
                      ? 'tw-border-emerald-700 tw-bg-emerald-700 tw-text-white'
                      : 'tw-border-slate-900 tw-bg-slate-900 tw-text-white')
                    : (container?.notes?.length > 0
                      ? 'tw-border-emerald-300 tw-bg-emerald-50 tw-text-emerald-700 hover:tw-bg-emerald-100'
                      : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50')"
                  @click="setTab('notes')"
                >
                  Notes
                  <span
                    v-if="container?.notes?.length > 0"
                    class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-600 tw-ml-2 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-white"
                    >
                          {{ container.notes.length }}
                  </span>
                </button>
                <button
                  v-if="isReefer"
                  type="button"
                  class="tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium"
                  :class="activeTab === 'reefer'
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                  @click="setTab('reefer')"
                >
                  Reefer
                </button>
                <button
                  v-if="container && container.order"
                  type="button"
                  class="tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium"
                  :class="activeTab === 'dispatch'
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                  @click="setTab('dispatch')"
                >
                  Dispatch
                </button>
                <button
                  v-if="enableVessel === true && container && container.vessel"
                  type="button"
                  class="tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium"
                  :class="activeTab === 'vessel'
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                  @click="setTab('vessel')"
                >
                  Vessel Tracking
                </button>
                <button
                  v-if="container && container.linerContainerEvents && container.linerContainerEvents.length > 0"
                  type="button"
                  class="tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium"
                  :class="activeTab === 'shipline'
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white'"
                  @click="setTab('shipline')"
                >
                  Shipline Events
                </button>
              </div>
            </div>

            <div class="tw-flex tw-flex-shrink-0 tw-items-center tw-gap-2">
              <Button
                v-if="container && !container.billOfLading && !editingBL"
                :isDefault="true"
                class="tw-px-2 tw-py-1 tw-text-xs"
                @click="addBL"
                title="Add Bill of Lading"
              >
                Add BL
              </Button>
            </div>
          </div>
        </div>

        <div
          v-if="container && !container.billOfLading && editingBL"
          class="tw-border-b tw-border-slate-200/70 tw-px-4 tw-py-3"
        >
          <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
            <InputField
              class="tw-w-[220px]"
              id="BL"
              v-model="editingBillOfLading"
              placeholder="Bill of Lading"
            ></InputField>
            <Button class="tw-px-2 tw-py-1 tw-text-xs" @click="saveBillOfLading">Save</Button>
            <Button class="tw-px-2 tw-py-1 tw-text-xs" :isGray="true" @click="cancelBLAddition">Cancel</Button>
          </div>
        </div>

        <div class="tw-flex-1 tw-min-h-0 tw-overflow-auto tw-px-4 tw-py-3">
          <div v-if="$apollo.queries.container.loading && (!container || container.id !== containerId)" class="tw-flex tw-items-center tw-justify-center tw-py-10">
            <font-awesome-icon icon="circle-notch" spin class="tw-h-8 tw-w-8 tw-text-slate-500" />
          </div>
          <div v-else-if="container">
            
            <!-- Details Tab -->
            <div v-if="activeTab === 'details'">
            
              <div class="tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-gradient-to-br tw-from-white/70 tw-via-white/50 tw-to-indigo-50/50 tw-shadow-sm tw-shadow-slate-900/5">
                <div class="tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-2 tw-border-b tw-border-slate-200/70 tw-px-4 tw-py-3 sm:tw-px-5">
                  <div class="tw-min-w-0">
                    <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                      <h2 class="tw-text-base tw-font-semibold tw-text-slate-900">Container details</h2>
                      <span v-if="container.owner" class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-700">{{ container.owner }}</span>
                      <span
                        v-if="container.isCancelled"
                        class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-rose-50 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-rose-800 tw-ring-1 tw-ring-inset tw-ring-rose-600/20"
                        :title="container.cancelledReason || 'Cancelled on order'"
                      >
                        Cancelled <span v-if="container.cancelledReason"> — {{ container.cancelledReason }}</span>
                      </span>
                      <span v-else-if="container.yardStatusDescription">
                        <YardStatusLabel :container="container" :enableStale="false"></YardStatusLabel>
                      </span>
                    </div>
                    <div class="tw-mt-0.5 tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-1 tw-text-sm tw-text-slate-600">
                      <div v-if="container.sizeType" class="tw-inline-flex tw-items-center tw-gap-1">
                        <span class="tw-text-slate-500">Size/Type</span>
                        <span class="tw-font-medium tw-text-slate-800">{{ container.sizeType }}</span>
                      </div>
                      <div class="tw-hidden sm:tw-block tw-text-slate-300">|</div>
                      <div class="tw-inline-flex tw-items-center tw-gap-1">
                        <span class="tw-text-slate-500">Terminal</span>
                        <span
                          class="tw-font-medium tw-text-slate-800 tw-p-1 tw-rounded-2xl" 
                          :class="`container-terminal-${container.terminal.toLowerCase()}`">{{ container.terminal || '—' }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="tw-flex tw-flex-shrink-0 tw-items-center tw-gap-2">
                    <div v-if="getIsEtaShownForYardStatus(container.yardStatus)" class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-1.5 tw-text-sm tw-text-slate-700">
                      <span class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500">ETA</span>
                      <span class="tw-font-semibold">{{ container.eta || '—' }}</span>
                    </div>
                    <div v-else-if="container.lfd && container.lfd.length > 2" class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-amber-200/70 tw-bg-amber-50/70 tw-px-2.5 tw-py-1.5 tw-text-sm tw-text-amber-900">
                      <span class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-amber-800">LFD</span>
                      <span class="tw-font-semibold">{{ container.lfd }}</span>
                    </div>
                    <div v-else class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-emerald-200/70 tw-bg-emerald-50/70 tw-px-2.5 tw-py-1.5 tw-text-sm tw-text-emerald-800">
                      <span class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide">No LFD</span>
                    </div>

                    <div>
                      <Button
                        @click="openEditContainerDetails"
                        icon="pen-to-square"
                      ></Button>
                    </div>
                  </div>
                </div>

                <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3 tw-px-4 tw-py-3 sm:tw-px-5">
                  <dl class="tw-grid tw-grid-cols-1 tw-gap-2">
                    <div class="tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5">
                      <dt class="tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500">Vessel</dt>
                      <dd class="tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900">{{ container.vessel ? container.vessel.name : 'Vessel Not Available' }}</dd>
                    </div>
                    <div class="tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5">
                      <dt class="tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500">Line</dt>
                      <dd class="tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900">{{ container.owner || '—' }}</dd>
                    </div>
                  </dl>

                  <dl class="tw-grid tw-grid-cols-1 tw-gap-2">
                    <div class="tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5">
                      <dt class="tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500">Pick-up terminal appointment</dt>
                      <dd class="tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900">
                        <span v-if="container.terminalAppointmentDate">{{ formatAppointmentDatetime(container.terminalAppointmentDate, container.terminalAppointmentHasTime, true) }}</span>
                        <span v-else class="tw-text-slate-500">—</span>
                      </dd>
                    </div>
                    <div class="tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5">
                      <dt class="tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500">Delivery appointment</dt>
                      <dd class="tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900">
                        <span v-if="container.deliveryAppointmentDate">{{ formatAppointmentDatetime(container.deliveryAppointmentDate, container.deliveryAppointmentHasTime, true) }}</span>
                        <span v-else class="tw-text-slate-500">—</span>
                      </dd>
                    </div>
                    <div class="tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5">
                      <dt class="tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500">Return terminal appointment</dt>
                      <dd class="tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900">
                        <span v-if="container.returnTerminalAppointmentDate">{{ formatAppointmentDatetime(container.returnTerminalAppointmentDate, container.returnTerminalAppointmentHasTime, true) }}</span>
                        <span v-else class="tw-text-slate-500">—</span>
                        <span 
                          v-if="getIsReturningToDifferentLocation(container.terminal, container.returnLocation)"
                          v-tippy="'pick-up terminal and return location are DIFFERENT!'"
                        >
                          <span
                            class="tw-font-medium tw-text-slate-800 tw-p-1 tw-border-2 tw-rounded-2xl tw-border-dashed tw-border-red-500 tw-mx-2 tw-my-1"
                            :class="getTerminalColorClassForLocation(container.returnLocation)">* {{ getLocationDisplayName(container.returnLocation) }}</span>
                        </span>
                      </dd>
                    </div>
                  </dl>
  
            
                  <Modal v-model:isOpen="isEditContainerDetailsModalOpen" @close="closeEditContainerDetails">
                    <template #title>
                      <div class="tw-text-base tw-font-semibold tw-tracking-tight tw-text-slate-900">Edit container</div>
                    </template>
                    <template #subtitle>
                      <div class="tw-text-sm tw-text-slate-600">Update fields, then save.</div>
                    </template>
                    <template #content>
                        <div class="tw-p-5">
                          <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-3">
                            <FilterableDropdown
                              autofocus
                              taggable
                              push-tag
                              v-model="editingContainer.size"
                              textLabel="Container Size"
                              placeholder="find &amp; select size..."
                              :options="containerSizes"
                              :components="{ Deselect: null }"
                            ></FilterableDropdown>
                            <FilterableDropdown
                              taggable
                              push-tag
                              v-model="editingContainer.type"
                              textLabel="Container Type"
                              placeholder="find &amp; select type..."
                              :options="containerTypes"
                              label="label"
                              :reduce="(type) => type.value"
                              :components="{ Deselect: null }"
                            ></FilterableDropdown>
                            <FilterableDropdown
                              class="sm:tw-col-start-1"
                              taggable
                              push-tag
                              v-model="editingContainer.vessel"
                              textLabel="Vessel Name"
                              placeholder="find &amp; select vessel..."
                              label="name"
                              :options="vessels || []"
                              :reduce="(vessel) => vessel.name"
                              :create-option="(vesselName) => ({ name: vesselName })"
                              :components="{ Deselect: null }"
                            ></FilterableDropdown>
                            <BaseDateTimePicker
                              v-if="hasBillOfLadingForEta"
                              type="date"
                              textLabel="Vessel ETA"
                              value-type="format"
                              format="MM/DD/YYYY"
                              :show-days-shortcuts="true"
                              controls-placement="popup"
                              v-model="editingContainer.eta"
                            >
                              <template #label-suffix>
                                <span
                                  class="tw-ml-1"
                                  v-tippy="'Expected vessel arrival. Shared for all containers on this bill of lading.'"
                                >
                                  <font-awesome-icon icon="circle-question" />
                                </span>
                              </template>
                            </BaseDateTimePicker>
                            <div
                              v-else
                              class="tw-rounded-xl tw-border tw-border-amber-200/70 tw-bg-amber-50/70 tw-p-3 tw-text-sm tw-text-amber-900"
                            >
                              Add a bill of lading before setting vessel ETA.
                            </div>
                            <BaseDateTimePicker
                              type="date"
                              textLabel="Last Free Day"
                              value-type="format"
                              format="MM/DD/YYYY"
                              :show-days-shortcuts="true"
                              controls-placement="popup"
                              v-model="editingContainer.lfd"
                            ></BaseDateTimePicker>
                            <FilterableDropdown
                              class="sm:tw-col-start-1"
                              taggable
                              push-tag
                              v-model="editingContainer.terminal"
                              textLabel="Terminal"
                              placeholder="find &amp; select terminal..."
                              :options="terminals"
                              label="label"
                              :reduce="(type) => type.value"
                              :components="{ Deselect: null }"
                            ></FilterableDropdown>
                            <div class="sm:tw-self-end sm:tw-pb-2">
                              <label class="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700">
                                <input
                                  v-model="editingContainer.isReturningToAnotherLocation"
                                  type="checkbox"
                                  class="tw-h-4 tw-w-4 tw-rounded tw-border-slate-300"
                                />
                                Return to Another Location?
                              </label>
                            </div>
                            <ContainerReturnLocationDropdown
                              v-if="editingContainer.isReturningToAnotherLocation"
                              v-model="editingContainer.returnLocation"
                              textLabel="Return Location"
                              placeholder="find &amp; select customer or terminal..."
                            ></ContainerReturnLocationDropdown>
                            <div class="sm:tw-col-start-1">
                              <BaseDateTimePicker
                                value-type="YYYY-MM-DD HH:mm"
                                date-format="MM/DD/YYYY" date-time-format="MM/DD/YYYY HH:mm"
                                :allow-time-toggling="true"
                                :show-days-shortcuts="true"
                                controls-placement="popup"
                                :minute-step="15"
                                textLabel="Pick-Up Terminal Appt"
                                time-panel-placement="beside-calendar"
                                v-model="editingContainer.terminalAppointmentDate"
                                v-model:has-time="editingContainer.terminalAppointmentHasTime"
                              ></BaseDateTimePicker>
                            </div>
                            <BaseDateTimePicker
                              value-type="YYYY-MM-DD HH:mm"
                              date-format="MM/DD/YYYY" date-time-format="MM/DD/YYYY HH:mm"
                              :allow-time-toggling="true"
                              :show-days-shortcuts="true"
                              controls-placement="popup"
                              time-panel-placement="beside-calendar"
                              :minute-step="15"
                              :textLabel="container.isExport ? 'Pick-Up Appt' : 'Delivery Appt'"
                              v-model="editingContainer.deliveryAppointmentDate"
                              v-model:has-time="editingContainer.deliveryAppointmentHasTime"
                            ></BaseDateTimePicker>
                            <BaseDateTimePicker
                              value-type="YYYY-MM-DD HH:mm"
                              date-format="MM/DD/YYYY" date-time-format="MM/DD/YYYY HH:mm"
                              :allow-time-toggling="true"
                              :show-days-shortcuts="true"
                              controls-placement="popup"
                              time-panel-placement="beside-calendar"
                              :minute-step="15"
                              textLabel="Return Terminal Appt"
                              v-model="editingContainer.returnTerminalAppointmentDate"
                              v-model:has-time="editingContainer.returnTerminalAppointmentHasTime"
                            ></BaseDateTimePicker>
                          </div>

                          <div class="tw-mt-5 tw-flex tw-justify-end tw-gap-2">
                            <Button :isGreen="true" icon="check" @click="saveEditContainerDetails" >Save</Button>
                            <Button :isRed="true" :isSecondary="true" @click="closeEditContainerDetails">Cancel</Button>
                          </div>
                        </div>
                    </template>
                  </Modal>                  
                
                  <!-- <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3 tw-mt-3 tw-p-3 tw-pl-5 tw-pr-5"> -->
                    
                    <!-- Customer Address + Drop-Off -->
                    <div class="tw-w-full tw-text-center tw-p-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5">
                      <h3 class="tw-text-base tw-font-semibold tw-text-slate-900">Drop-off location</h3>
                      <!-- Editing -->
                      <div v-if="isEditingCustomer" class="tw-mt-2 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-900/5 tw-p-4 tw-text-left">
                        <div class="tw-text-sm tw-text-slate-600">Select a customer for the drop-off.</div>
                        <div class="tw-mt-3">
                          <FilterableDropdown
                            v-model="customerQuery"
                            @search-change="onReceivingCustomerSearch"
                            id="Customer"
                            :options="receivingCustomers || []"
                            placeholder="Enter Drop-Off Name"
                            class="tw-w-full"
                            :customLabel="
                              (x) => (x.displayName ? x.displayName : x.name)
                            "
                          ></FilterableDropdown>
                        </div>

                        <div class="tw-mt-4 tw-flex tw-justify-center tw-gap-2">
                          <button
                            class="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-700 hover:tw-bg-white"
                            type="button"
                            @click="cancelCustomerEdit"
                          >
                            Cancel
                          </button>
                          <button
                            class="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-transparent tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-slate-800 disabled:tw-opacity-60"
                            type="button"
                            v-on:click="updateCustomer"
                            :disabled="!customerQuery"
                          >
                            Save Drop-Off
                          </button>
                        </div>
                      </div>
                      <!-- Read-only -->
                      <div v-else>
                        <div v-if="container.customer">
                          <p class="tw-mb-0">
                            {{ container.customer.name }}
                          </p>
                          <div
                            class="tw-mt-0"
                            v-if="container.customer.deliveryAddress"
                          >
                            <p
                              class="tw-mt-0 tw-mb-0"
                            >
                              {{
                                container.customer.deliveryAddress.streetAddress
                              }}
                            </p>
                            <p class="tw-mt-0">
                              {{
                                addressLine3(container.customer.deliveryAddress)
                              }}
                            </p>
                          </div>
                          <div class="tw-mt-3 tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-center tw-gap-2">
                            <div>
                              <button
                                v-if="canAddDropOff"
                                class="tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-slate-800"
                                type="button"
                                v-on:click="startCustomerEdit"
                              >
                                Edit Drop-Off
                              </button>
                              <button
                                v-else
                                class="tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-opacity-60"
                                type="button"
                                title="Drop-off cannot be edited after order is created"
                                disabled
                              >
                                Edit Drop-Off
                              </button>
                            </div>

                            <div>
                              <button
                                v-if="container.billOfLading && !container.order"
                                class="tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-slate-800"
                                @click="showNewOrder(container)"
                              >
                                Add Order
                              </button>
                              <button
                                v-else-if="!container.billOfLading"
                                class="tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-opacity-60"
                                title="Add Bill of Lading to this container to add Orders"
                                disabled
                              >
                                Add Order
                              </button>
                            </div>
                          </div>
                        </div>
                        <div v-else-if="canAddDropOff" class="tw-mt-3 tw-flex tw-w-full tw-justify-center">
                          <button
                            class="tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-slate-800"
                            type="button"
                            @click="startCustomerEdit"
                          >
                            Add Drop-Off
                          </button>
                        </div>
                        <div v-else class="tw-mt-3 tw-flex tw-w-full tw-justify-center">
                          <button
                            class="tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-opacity-60"
                            type="button"
                            title="Drop-off cannot be added after order is created"
                            disabled
                          >
                            Add Drop-Off
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="tw-w-full tw-text-center tw-p-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5">
                      <!-- Order Details -->
                      <div v-if="container.order" class="tw-mt-4 tw-flex tw-flex-col tw-items-center">
                        <h3 class="tw-text-base tw-font-semibold tw-text-slate-900">Order Details</h3>
                        <p class="tw-mt-0 tw-mb-0">
                          Order # {{ container.order.id }}
                        </p>
                        <p v-if="container.order.status == 'In Progress'">
                          <span class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-emerald-800">In Progress</span>
                        </p>
                        <p v-else-if="container.order.status == 'Complete'">
                          <span class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-amber-800">Completed</span>
                        </p>
                        <a
                          v-if="container.order"
                          class="tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-slate-800"
                          @click="showOrder(container.order)"
                        >
                          Order Details
                        </a>
                      </div>
                    </div>
                  <!-- </div> -->
                </div>
              </div>


              <div>
                <h2 class="tw-mt-6 tw-text-base sm:tw-text-lg tw-font-semibold tw-text-slate-900">Container Events at Terminal</h2>
                <ContainerTerminalEventsTable v-if="container.containerEvents.length > 0" :containerEvents="container.containerEvents" :terminal="container.dischargeTerminal" />
                <p v-if="!container.containerEvents || container.containerEvents.length === 0" class="tw-text-sm tw-text-slate-500">No terminal events recorded yet.</p>
              </div>

              <!-- Container (Un)Archive Buttons -->
              <div v-if="container && (showArchiveButton || showUnarchiveButton)" class="tw-mt-6 tw-border-t tw-border-slate-200/70 tw-pt-4">
                <div v-if="!isArchiveConfirmOpen">
                  <Button
                    v-if="showArchiveButton"
                    :isRed="true"
                    :isSecondary="true"
                    class="tw-px-3 tw-py-1.5 tw-text-xs"
                    @click="isArchiveConfirmOpen = true"
                  >
                    <font-awesome-icon icon="box-archive" class="tw-mr-1.5" />
                    Archive Container
                  </Button>
                  <Button
                    v-if="showUnarchiveButton"
                    :isRed="true"
                    :isSecondary="true"
                    class="tw-px-3 tw-py-1.5 tw-text-xs"
                    @click="isArchiveConfirmOpen = true"
                  >
                    <font-awesome-icon icon="box-open" class="tw-mr-1.5" />
                    Unarchive Container
                  </Button>
                </div>
                
                
                <div v-else class="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-rounded-xl tw-border tw-border-rose-200 tw-bg-rose-50/60 tw-px-4 tw-py-3 tw-text-center">
                  <span class="tw-text-sm tw-font-medium tw-text-rose-800">
                    Are you sure you want to {{ showArchiveButton ? 'archive' : 'unarchive' }} this container?
                  </span>
                  <div class="tw-flex tw-gap-2">
                    <Button
                      :isRed="true"
                      class="tw-px-3 tw-py-1.5 tw-text-xs"
                      @click="confirmArchiveAction"
                    >
                      Yes, {{ showArchiveButton ? 'Archive' : 'Unarchive' }}
                    </Button>
                    <Button
                      :isGray="true"
                      class="tw-px-3 tw-py-1.5 tw-text-xs"
                      @click="isArchiveConfirmOpen = false"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </div> 
            
            <div v-else-if="activeTab === 'notes'">
              <AddNotesArea
                  @addedNote="onAddedNote"
                  :notes="container.notes"
                  :archivedNotes="container.archivedNotes"
                  :container="container"
                ></AddNotesArea>
            </div>

            <div v-else-if="activeTab === 'reefer' && isReefer">
              <ContainerReeferDetails :container="container" />
            </div>

            <div v-else-if="activeTab === 'dispatch'">
              <div class="tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-p-3 sm:tw-p-4">
                <div class="tw-mb-3 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2">
                  <h2 class="tw-text-base sm:tw-text-lg tw-font-semibold tw-text-slate-900">Dispatch</h2>
                  <p
                    v-if="container.isCancelled"
                    class="tw-text-sm tw-text-rose-800"
                  >
                    Trips cannot be edited - container is cancelled on its order.
                  </p>
                  <div v-else class="tw-text-sm tw-text-slate-600">Trips</div>
                </div>
                <div class="tw-overflow-x-auto">
                  <ContainerTripsTable
                    v-if="container && container.order"
                    caller="dispatch"
                    :editable="!container.isCancelled"
                    :order="container.order"
                    :container="container"
                    :trips="container.trips"
                    :drivers="drivers"
                    @refreshOrders="refreshTrips"
                    @refreshorders="refreshTrips"
                  />
                </div>
              </div>

              

            </div><!--/ End of container details tab -->

            <div v-else-if="activeTab === 'vessel'">
              <div class="tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-p-3 sm:tw-p-4">
                <VesselFinderEmbed
                  v-if="container && container.vessel && container.vessel.mssi"
                  :mssi="container.vessel.mssi"
                  :height="560"
                />
                <div v-else class="tw-text-sm tw-text-slate-600">No vessel tracking available for this container.</div>
              </div>
            </div>

            <div v-else-if="activeTab === 'shipline'">
              <div class="tw-text-sm tw-text-slate-600">No shipline events view configured.</div>
            </div>

          </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ContainerQuery from '@/gql/containers/Container.gql';
import AddNotesArea from '@/components/core/AddNotesArea.vue';
import UpdateCustomerName from '@/gql/customers/UpdateCustomerName.gql';
import ReceivingCustomersQuery from '@/gql/customers/ReceivingCustomers.gql';
import DriversQuery from '@/gql/drivers/Drivers.gql';

import ContainerTripsTable from '../Orders/ContainerTripsTable.vue';
import UpdateBLForContainer from '../../gql/containers/mutations/UpdateBLForContainer.gql';
import { ACTIVE_BLS_REFETCH } from '@/utils/active_BLs_apollo';
import UpdateContainerDetailsMutation from '../../gql/containers/mutations/UpdateContainerDetails.gql';
import {
  getApolloClientFromVm,
  writeContainerEtaToCache,
} from '@/utils/containerApolloCache';
import FilterableDropdown from '../core/FilterableDropdown.vue';
import BaseDateTimePicker from '../core/DateTime/BaseDateTimePicker.vue';
import moment from 'moment';
import Button from '../core/Button.vue';
import { addressMixin } from '../../utils/address';
import InputField from '../core/Input/InputField.vue';
import CopyButton from '../core/CopyButton.vue';
import YardStatusLabel from '../UI/YardStatusLabel.vue';
import ContainerTerminalEventsTable from './Terminal/ContainerTerminalEventsTable.vue';
import VesselFinderEmbed from './Vessel/VesselFinderEmbed.vue';
import ContainerReeferDetails from '@/components/Container/ContainerReeferDetails.vue';
import ContainerReturnLocationDropdown from '@/components/Container/ContainerReturnLocationDropdown.vue';

import Modal from '../core/Modal/Modal.vue';

import {
  containerSizes,
  containerTypes,
  terminals,
  getIsReeferSizeType,
  getIsReturningToDifferentLocation,
  getLocationDisplayName,
  getTerminalColorClassForLocation,
  getIsEtaShownForYardStatus,
} from '../../utils/container';
import { datetimeFormatMixin } from '../../utils/date';

// import DropdownList from '../core/DropdownList.vue';

export default defineComponent({
  name: 'ContainerModal',
  props: {
    containerId: {
      required: true,
    },
    // why this object? because it is already loaded from the parent
      //  and we can show essential container info for the Container modal
      //  while modal loads the even more details container details that the Container Table did not load
      //  (TODO: why not just load it all in one go at the ContainerTable level? or make the Container Modal 
      //   query smaller: just the stuff missing like trips)
    containerFromList: Object,
    customer: String,
    enableVessel: Boolean,
    vessels: Array,
  },
  mixins: [addressMixin, datetimeFormatMixin],
  data() {
    return {
      activeTab: 'details',
      editingBL: false,
      editingBillOfLading: undefined,
      receivingCustomerNameQuery: '',
      isEditingCustomer: false,
      customerQuery: null,
      receivingCustomerSearchDebounceTimer: undefined,
      isEditContainerDetailsModalOpen: false,
      showContainerDetails: true,
      editingContainer: {
        vessel: undefined,
        size: undefined,
        type: undefined,
        eta: undefined,
        lfd: undefined,
        yardStatus: undefined,
        terminal: undefined,
        terminalAppointmentDate: undefined,
        terminalAppointmentHasTime: true,
        deliveryAppointmentDate: undefined,
        deliveryAppointmentHasTime: true,
        isReturningToAnotherLocation: false, // UI-only: unchecked clears returnLocation on save
        returnLocation: null,
        returnTerminalAppointmentDate: undefined,
        returnTerminalAppointmentHasTime: true,
      },
      containerTypes,
      containerSizes,
      terminals,
      isArchiveConfirmOpen: false,
    };
  },
  components: {
    AddNotesArea,
    FilterableDropdown,
    Button,
    InputField,
    CopyButton,
    BaseDateTimePicker,
    ContainerTerminalEventsTable,
    ContainerTripsTable,
    VesselFinderEmbed,
    YardStatusLabel,
    ContainerReeferDetails,
    ContainerReturnLocationDropdown,
    Modal,
  },
  computed: {
    isReefer(): boolean {
      return getIsReeferSizeType((this as any).container?.sizeType);
    },
    showArchiveButton(): boolean {
      return !(this as any).isEditContainerDetailsModalOpen && (this as any).container.isActive;
    },
    showUnarchiveButton(): boolean {
      return !(this as any).isEditContainerDetailsModalOpen && !(this as any).container.isActive;
    },
    canAddDropOff(): boolean {
      return !((this as any).container?.order);
    },
    hasBillOfLadingForEta(): boolean {
      const container = (this as any).container;
      return Boolean(container?.billOfLading?.id || container?.billOfLading?.billOfLadingNumber);
    },
  },

  beforeUnmount() {
    window.clearTimeout((this as any).receivingCustomerSearchDebounceTimer);
  },

  methods: {
    getIsReturningToDifferentLocation,
    getLocationDisplayName,
    getTerminalColorClassForLocation,
    getIsEtaShownForYardStatus,
    setTab(tab: string) {
      (this as any).activeTab = tab;
    },
    // onRequestClose() { // commented out since this is now wrapped by a Modal 
    //   (this as any).isArchiveConfirmOpen = false; // i wonder if that will be a problem
    //   (this as any).$emit('close');
    // },
    addBL() {
      (this as any).editingBL = true;
    },
    toggleContainerDetails() {
      (this as any).showContainerDetails = true;
    },
    toggleDispatch() {
      (this as any).showContainerDetails = false;
    },
    saveBillOfLading() {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: UpdateBLForContainer,
          variables: {
            billOfLadingNumber: vm.editingBillOfLading,
            containerId: vm.container.id,
          },
          refetchQueries: [ACTIVE_BLS_REFETCH],
          awaitRefetchQueries: true,
        })
        .then((result) => {
          console.log('updatedBL');
          vm.editingBL = false;
          vm.editingBillOfLading = undefined;
          vm.$apollo.queries.container.refetch();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    cancelBLAddition() {
      (this as any).editingBL = false;
    },
    confirmArchiveAction() {
      const vm = (this as any);
      if (vm.showArchiveButton) {
        vm.archiveContainer(vm.container.id);
      } else {
        vm.unarchiveContainer(vm.container.id);
      }
    },
    archiveContainer(containerIndex: number) {
      (this as any).isArchiveConfirmOpen = false;
      (this as any).$emit('archiveContainer', containerIndex);
    },
    unarchiveContainer(containerIndex: number) {
      (this as any).isArchiveConfirmOpen = false;
      (this as any).$emit('unarchiveContainer', containerIndex);
    },
    onReceivingCustomerSearch(customerName) {
      const vm = this as any;

      window.clearTimeout(vm.receivingCustomerSearchDebounceTimer);
      vm.receivingCustomerSearchDebounceTimer = window.setTimeout(() => {
        vm.receivingCustomerNameQuery = customerName;
      }, 300);
    },
    openEditContainerDetails() {
      const vm = (this as any);

      vm.isEditContainerDetailsModalOpen = true;

      const formatDateForPicker = (dateStr) => {
        if (!dateStr) return undefined;
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
    
        const pad = (n) => n.toString().padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
      };

      const containerEta = vm.container?.eta;
      vm.editingContainer = {
        vessel: vm.container?.vessel?.name,
        size: undefined,
        type: undefined,
        eta:
          containerEta && containerEta !== 'N/A'
            ? vm.formatDateOnlyForPicker(containerEta)
            : undefined,
        lfd: vm.formatDateOnlyForPicker(vm.container?.lfd),
        yardStatus: undefined,
        terminal: vm.container?.terminal,
        terminalAppointmentDate: formatDateForPicker(vm.container?.terminalAppointmentDate),
        terminalAppointmentHasTime: vm.container?.terminalAppointmentHasTime ?? true,
        deliveryAppointmentDate: formatDateForPicker(vm.container?.deliveryAppointmentDate),
        deliveryAppointmentHasTime: vm.container?.deliveryAppointmentHasTime ?? true,
        isReturningToAnotherLocation: getIsReturningToDifferentLocation(vm.container?.terminal, vm.container?.returnLocation),
        returnLocation: vm.container?.returnLocation ?? null,
        returnTerminalAppointmentDate: formatDateForPicker(vm.container?.returnTerminalAppointmentDate),
        returnTerminalAppointmentHasTime: vm.container?.returnTerminalAppointmentHasTime ?? true,
      };

      if (vm.container?.sizeType && vm.container.sizeType !== 'N/A') {
        const raw = vm.container.sizeType;
        const sizePart = raw.substring(0, 2);
        const typePart = raw.substring(2);

        if ((this as any).containerSizes.includes(sizePart)) {
          vm.editingContainer.size = sizePart;
        }

        const typeOption = (this as any).containerTypes.find(t => t.value === typePart);
        if (typeOption) {
          vm.editingContainer.type = typeOption.value;
        }
      }
    },
    closeEditContainerDetails() {
      const vm = this as any;
      vm.isEditContainerDetailsModalOpen = false;
      vm.editingContainer = {
        vessel: undefined,
        size: undefined,
        type: undefined,
        eta: undefined,
        lfd: undefined,
        yardStatus: undefined,
        terminal: undefined,
        terminalAppointmentDate: undefined,
        terminalAppointmentHasTime: true,
        deliveryAppointmentDate: undefined,
        deliveryAppointmentHasTime: true,
        isReturningToAnotherLocation: false, // UI-only: unchecked clears returnLocation on save
        returnLocation: null,
        returnTerminalAppointmentDate: undefined,
        returnTerminalAppointmentHasTime: true,
      };
    },
    // Shared by the date-only fields (vessel ETA, LFD)
    formatDateOnlyForPicker(date) {
      if (!date || date === 'N/A') return undefined;
      const m = moment(
        date,
        ['MM/DD/YYYY', 'MM/DD/YY', 'MM/DD', moment.ISO_8601],
        true,
      );
      return m.isValid() ? m.format('MM/DD/YYYY') : undefined;
    },
    formatDateOnlyForMutation(date) {
      if (date == null || date === '') {
        return '';
      }
      if (date instanceof Date) {
        return moment(date).format('MM/DD/YYYY');
      }
      const m = moment(String(date).trim(), ['MM/DD/YYYY', 'YYYY-MM-DD'], true);
      return m.isValid() ? m.format('MM/DD/YYYY') : String(date).trim();
    },
    saveEditContainerDetails() {
      const vm = this as any;
      if (!vm.container?.id) return;

      const variables: Record<string, unknown> = {
        containerId: vm.container.id,
        vessel: vm.editingContainer.vessel,
        containerSize: vm.editingContainer.size,
        containerType: vm.editingContainer.type,
        terminal: vm.editingContainer.terminal,
        terminalAppointmentDate: vm.editingContainer.terminalAppointmentDate || '',
        terminalAppointmentHasTime: vm.editingContainer.terminalAppointmentHasTime,
        deliveryAppointmentDate: vm.editingContainer.deliveryAppointmentDate || '',
        deliveryAppointmentHasTime: vm.editingContainer.deliveryAppointmentHasTime,
        // empty string clears it in the backend
        returnLocationId: (vm.editingContainer.isReturningToAnotherLocation && vm.editingContainer.returnLocation?.id) || '',
        returnTerminalAppointmentDate: vm.editingContainer.returnTerminalAppointmentDate || '',
        returnTerminalAppointmentHasTime: vm.editingContainer.returnTerminalAppointmentHasTime,
      };

      if (vm.hasBillOfLadingForEta) {
        variables.eta = vm.formatDateOnlyForMutation(vm.editingContainer.eta);
      }

      // Sent only when edited: the shown LFD may be the scrape-event fallback, which
      // shouldn't be copied onto the container just by saving other fields.
      const lfdForMutation = vm.formatDateOnlyForMutation(vm.editingContainer.lfd);
      const currentLfdForPicker = vm.formatDateOnlyForPicker(vm.container?.lfd);
      const currentLfd = vm.formatDateOnlyForMutation(currentLfdForPicker);
      const hasLfdChanged = lfdForMutation !== currentLfd;
      if (hasLfdChanged) {
        variables.lfd = lfdForMutation;
      }

      vm.$apollo
        .mutate({
          mutation: UpdateContainerDetailsMutation,
          variables,
        })
        .then((result: { data?: { updateContainerDetails?: { container?: any } } }) => {
          const updated = result?.data?.updateContainerDetails?.container;
          vm.closeEditContainerDetails();
          const didUpdateEta = vm.hasBillOfLadingForEta && variables.eta !== undefined;
          if (didUpdateEta && updated) {
            const eta = updated.eta ?? 'N/A';
            vm.container = { ...vm.container, eta };
            const client = getApolloClientFromVm(vm);
            if (client && updated.id != null) {
              writeContainerEtaToCache(client, updated.id, eta);
            }
            const blId = updated.billOfLading?.id ?? vm.container?.billOfLading?.id;
            vm.$emit(
              'updateContainer',
              blId != null ? { billOfLadingId: blId, eta } : undefined,
            );
          } else {
            vm.$emit('updateContainer');
          }
          vm.$apollo.queries.container.refetch();
        })
        .catch(() => {
          vm.$emit('updateContainer');
          vm.closeEditContainerDetails();
        });
    },

    addOrderUrl(container: any) {
      const billOfLadingNumber = container?.billOfLading?.billOfLadingNumber;
      const dropoffId = container?.customer?.id;
      const containerId = container?.id;
      const query = new URLSearchParams();

      if (billOfLadingNumber) {
        query.set('billOfLadingNumber', String(billOfLadingNumber));
      }
      if (dropoffId) {
        query.set('dropoff', String(dropoffId));
      }
      if (containerId) {
        query.set('containerId', String(containerId));
      }

      const queryString = query.toString();
      return queryString ? `/orders/new?${queryString}` : '/orders/new';
    },
    customerUrl(customer: any) {
      return `/customers/${customer.id}`;
    },
    orderUrl(order: any) {
      return `/orders/${order.id}`;
    },
    showCustomer(customer: any) {
      (this as any).$router.push(this.customerUrl(customer));
    },
    showOrder(order: any) {
      // this.$router.push(this.orderUrl(order));
      (this as any).$emit('showOrder', this.orderUrl(order));
    },
    showNewOrder(container: any) {
      (this as any).$emit('showNewOrder', this.addOrderUrl(container));
    },
    startCustomerEdit() {
      const vm = (this as any);
      if (!vm.canAddDropOff) {
        return;
      }
      vm.isEditingCustomer = true;
      vm.customerQuery = vm.container && vm.container.customer ? vm.container.customer : null;
    },

    cancelCustomerEdit() {
      const vm = (this as any);
      vm.isEditingCustomer = false;
      vm.customerQuery = null;
      vm.receivingCustomerNameQuery = '';
    },
    updateContainer() {
      (this as any).$emit('updateContainer');
      console.log('tring to update container');
    },

    onAddedNote(notes: any[]) {
      const vm = (this as any);
      if (vm.$apollo?.queries?.container) {
        vm.$apollo.queries.container.refetch();
      }
      vm.updateContainer();
    },
    refreshTrips() {
      (this as any).$apollo.queries.container.refetch();
    },
    updateCustomer() {
      const vm = (this as any);

      if (vm.customerQuery && vm.customerQuery.name !== '') {
        vm.$apollo
          .mutate({
            mutation: UpdateCustomerName,
            variables: {
              customerName: vm.customerQuery.name,
              customerId: vm.customerQuery.id ? Number(vm.customerQuery.id) : null,
              containerId: Number(vm.container.id),
            },
            refetchQueries: [ACTIVE_BLS_REFETCH],
          })
          .then((data) => {
            vm.isEditingCustomer = false;
            return vm.$apollo.queries.container.refetch().then(() => {
              vm.updateContainer();
              return data;
            });
          })
          .then((data) => {
            console.log(data);
          })
          .catch((error) => {
            // (this as any).isEditingCustomer = false;
            console.error(error);
            (this as any).customerQuery = null;
          });
      }
    },
  },
  ...{
    // for some reason hiding the apollo parts behind this "...{}" prevents the type errors
    apollo: {
      drivers: {
        query: DriversQuery,
        skip() {
          return (this as any).activeTab !== 'dispatch';
        },
      },
      receivingCustomers: {
        query: ReceivingCustomersQuery,
        debounce: 300,
        variables() {
          // Use vue reactive properties here
          return {
            name: (this as any).receivingCustomerNameQuery,
          };
        },
      },
      container: {
        query: ContainerQuery,
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
        variables() {
          return {
            id: (this as any).containerId,
          };
        },
        skip() {
          return (this as any).containerId === -1;
        },
        error(error) {
          console.error('Error while getting container', error);
        },
      },
    },
  },
} as any);
</script>

<style lang="scss">
.container-terminal-ets {
  background-color: #9DC284 !important;
}

.container-terminal-trapac {
  background-color: #A9C2F0 !important;
}

.container-terminal-oict {
  background-color: #ffbf49 !important;
}
</style>

